export default __webpack_public_path__ + "static/media/end_call.96aeef05.png";